import React, { ComponentProps } from 'react';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { Form, Option, Row, Select, SelectParam, SonForm, SubmitButton, useForm } from '../../../_lib/Form2';
import { useHtmlValidId } from '../../../hooks/useHtmlValidId';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { useRefreshBlock } from '../../../_lib/BlockFetcher';

type DefaultSortOrderOption = { value: 'eventStartDate' | 'eventStartDateRev' | 'title' | 'titleDescending' };
type DefaultFilterTypeOption = { value: 'inFutureDay' | 'inPastDay' | 'all' };
type EventListDisplayTypeOption = { value: 'table' | 'teaser' | 'tile' };

type EventListEditProps = {
  form: SonForm<
    | SelectParam<'eventListDisplayType', EventListDisplayTypeOption>
    | SelectParam<'defaultSortOrder', DefaultSortOrderOption>
    | SelectParam<'defaultFilterType', DefaultFilterTypeOption>
  >;
};

function EventListDetailsEdit({ form }: EventListEditProps) {
  const { t } = useSonTranslation('EventList');
  const { refresh } = useRefreshBlock();
  const id = useHtmlValidId();
  const { formProps, params, fetchState } = useForm({ form, onSuccess: () => refresh() });

  const eventListDisplayType = params.getByName('eventListDisplayType');
  const defaultSortOrder = params.getByName('defaultSortOrder');
  const defaultFilterType = params.getByName('defaultFilterType');
  const eventListDisplayTypeOptions: Record<EventListDisplayTypeOption['value'], string> = {
    table: t('inputs.eventListDisplayType.options.table'),
    teaser: t('inputs.eventListDisplayType.options.teaser'),
    tile: t('inputs.eventListDisplayType.options.tile'),
  };

  return (
    <Form id={`event-list-edit-view-${id}`} {...formProps}>
      <Row>
        <Select label={t('inputs.eventListDisplayType.label')} param={eventListDisplayType}>
          {eventListDisplayType.options.map(option => (
            <Option key={option.value} value={option.value}>
              {eventListDisplayTypeOptions[option.value]}
            </Option>
          ))}
        </Select>
      </Row>
      <Row>
        <Select label={t('views.edit.defaultFilterType.label')} param={defaultFilterType}>
          {defaultFilterType.options.map(option => {
            return (
              <Option key={option.value} value={option.value}>
                {t(`FilterEventType:sortOptions.${option.value}`)}
              </Option>
            );
          })}
        </Select>
      </Row>
      <Row>
        <Select label={t('views.edit.defaultSortOrder.label')} param={defaultSortOrder}>
          {defaultSortOrder.options.map((option: DefaultSortOrderOption) => (
            <Option key={option.value} value={option.value}>
              {t(`ResultListSettings:sort.options.${option.value}`)}
            </Option>
          ))}
        </Select>
      </Row>
      <Row>
        <SubmitButton
          buttonLabel={t(`phrases:saveSettings`)}
          messageSuccess={t(`phrases:changeSuccesfull`)}
          messageSending={t(`phrases:changeSending`)}
          messageFail={t(`phrases:changesCouldNotBeSaved`)}
          fetchState={fetchState}
        />
      </Row>
    </Form>
  );
}

export const EventListDetailsEditView = asFetchableView(EventListDetailsEdit);
export type EventListDetailsEditView = ComponentProps<typeof EventListDetailsEditView>;
